import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ListenLive from "@/components/ListenLive";
import SnoozeButton from "@/components/SnoozeButton";
import LatestEpisodes from "@/components/LatestEpisodes";
import FollowJourney from "@/components/FollowJourney";
import Donations from "@/components/Donations";
import SubmitMusic from "@/components/SubmitMusic";
import About from "@/components/About";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App overflow-x-clip bg-cream font-sans text-ink">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <ListenLive />
                <SnoozeButton />
                <LatestEpisodes />
                <FollowJourney />
                <Donations />
                <SubmitMusic />
                <About />
            </main>
            <Footer />
            <Toaster position="bottom-center" richColors />
        </div>
    );
}

export default App;
